import React from 'react';

const Footer = () => {
  return (
    <footer className="w-full">
      {/* Top footer area */}
      <div
        className="w-full"
        style={{ backgroundColor: '#F2F0E7' }}
      >
        <div className="container-responsive padding-responsive">
          <div className="grid grid-cols-1 md:grid-cols-4 items-center gap-6 md:gap-8 text-dark" style={{ fontFamily: 'Poppins, sans-serif' }}>
            {/* Mobile: Logo and Address on left, Phone and Email on right */}
            <div className="md:hidden flex justify-between items-start w-full">
              <div className="flex flex-col items-start">
                <div className="flex items-center mb-3">
                  <img
                    src="/Logo.png"
                    alt="HIK Textiles"
                    className="h-12 sm:h-14 w-auto object-contain"
                  />
                </div>
                <div className="text-left">
                  <p className="text-xs sm:text-sm text-[#272525] leading-relaxed">
                    218 C First Floor,<br/> Commerical Broadway,<br/> DHA Phase 8, Lahore-Pakistan
                  </p>
                </div>
              </div>
              <div className="flex flex-col items-end">
                <div className="text-right mb-3">
                  <p className="text-xs sm:text-sm text-[#272525]">
                    +92 (42) 32364707
                  </p>
                </div>
                <div className="text-right">
                  <p className="text-xs sm:text-sm text-[#272525]">
                    info@hikenterprises.com
                  </p>
                </div>
              </div>
            </div>

            {/* Desktop: Logo */}
            <div className="hidden md:flex items-center md:justify-start justify-center">
              <img
                src="/Logo.png"
                alt="HIK Textiles"
                className="h-14 lg:h-16 xl:h-20 w-auto object-contain"
              />
            </div>

            {/* Desktop: Phone */}
            <div className="hidden md:block text-center md:text-center">
              <p className="text-sm md:text-base lg:text-lg text-[#272525]">
                +92 (42) 32364707
              </p>
            </div>

            {/* Desktop: Email */}
            <div className="hidden md:block text-center md:text-center pr-14 md:pr-18 lg:pr-22">
              <p className="text-sm md:text-base lg:text-lg text-[#272525]">
                info@hikenterprises.com
              </p>
            </div>

            {/* Desktop: Address */}
            <div className="hidden md:block text-center md:text-left">
              <p className="text-sm md:text-base lg:text-lg text-[#272525] leading-relaxed">
                218 C First Floor,<br/> Commerical Broadway,<br/> DHA Phase 8, Lahore-Pakistan
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div
        className="w-full"
        style={{ backgroundColor: '#A6A88F' }}
      >
        <p
          className="text-center text-white/90 text-xs sm:text-sm py-3 sm:py-2"
          style={{ fontFamily: 'Poppins, sans-serif' }}
        >
          © 2025, All Rights Reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;